// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3fYKN","notes":"Notes_notes__31CNh","note":"Notes_note__1eBMO","markdown":"Notes_markdown__24FI9"};